import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { absenceUrl } from './constants';
import type { AbsenceQueryParams } from './useAbsences';

export default function prefetchAbsences(
  client: APIClient,
  queryParams: AbsenceQueryParams = {},
) {
  prefetchQuery(absenceUrl, client, { queryParams });
}
